import api from './api';
import { Movement } from '../types/Movement';

const movementService = {
  getAll: () => api.get<Movement[]>('/movements'),

  getById: (id: string) => api.get<Movement>(`/movements/${id}`),

  getByInvestmentSheet: (investmentSheetId: string) =>
    api.get<Movement[]>(`/movements/investment-sheet/${investmentSheetId}`),

  getByPhase: (phaseId: string) =>
    api.get<Movement[]>(`/movements/phase/${phaseId}`),

  create: (movement: Partial<Movement>) =>
    api.post<Movement>('/movements', movement),

  update: (id: string, movement: Partial<Movement>) =>
    api.put<Movement>(`/movements/${id}`, movement),

  delete: (id: string) =>
    api.delete(`/movements/${id}`),
};

export default movementService;
